import React, {useEffect, useState} from "react";
import {create, getById, update} from "../../../services/sale.service";
import {getById as getFileById} from "../../../services/file.service";
import {NavigateFunction, useNavigate, useParams} from "react-router-dom";
import * as Yup from 'yup';
import {useFormik} from 'formik';
import {
  AutocompleteInputChangeReason,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Chip as ChipMaterial,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  IconButton as IconButtonMaterial,
} from "@mui/material";
import {GridSaveAltIcon} from "@mui/x-data-grid";
import {ArrowBackIosNew} from "@mui/icons-material";
import showNotification from "../../utils/Notify";
import {Box, Breadcrumbs, Button, Card, Grid, Stack, Chip, Typography} from "@mui/joy";
import {Experimental_CssVarsProvider as CssVarsProvider} from "@mui/material/styles";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ISale from "../../../types/sale.type";
import moment from "moment";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {Moment} from "moment/moment";
import {getActiveClients} from "../../../services/client.service";
import IClient from "../../../types/client.type";
import {Autocomplete} from "@mui/lab";
import {findServiceOrders} from "../../../services/service-order.service";
import IServiceOrder from "../../../types/service-order.type";
import Divider from "@mui/joy/Divider";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import IconButton from "@mui/joy/IconButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import IFile from "../../../types/file.type";
import {CurrencyType} from "../../../types/enumeration/CurrencyType";
import {SaleStatus} from "../../../types/enumeration/SaleStatus";
import {CurrencyTypeNames} from "../../../types/enumeration/CurrencyTypeNames";
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import ConfirmationModal from "../../utils/ConfirmationModal";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import {SaleStatusColors} from "../../../types/enumeration/SaleStatusColors";
import {SaleStatusNames} from "../../../types/enumeration/SaleStatusNames";
import ISaleType from "../../../types/sale-type.type";
import {getActiveSaleTypes} from "../../../services/sale-type.service";
import {downloadFile} from "../../../services/file-download.service";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import DeleteIcon from '@mui/icons-material/Delete';

const SaleForm: React.FC = () => {
  let navigate: NavigateFunction = useNavigate();
  const { id } = useParams();
  const [clients, setClients] = useState<Array<IClient>>([]);
  const [saleTypes, setSaleTypes] = useState<Array<ISaleType>>([]);
  const [selectedServiceOrders, setSelectedServiceOrders] = useState<any>(null);
  const [serviceOrders, setServiceOrders] = useState<Array<IServiceOrder>>([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = React.useState(false);
  const [selectedStatus, setSelectedStatus] = React.useState<SaleStatus | null>(null);
  const [modalTitle, setModalTitle] = React.useState("");
  const [modalMessage, setModalMessage] = React.useState("");
  const [editable, setEditable] = React.useState(true);
  const [files, setFiles] = useState<Array<File>>([]);

  const initialValues: ISale = {
    id: null,
    client: null,
    saleType: null,
    presentationDate: null,
    estimatedCollectionDate: null,
    effectiveCollectionDate: null,
    invoiceNumber: "",
    serviceOrder: null,
    invoiceFile: null,
    uploadInvoiceFile: null,
    retentionsFile: null,
    uploadRetentionsFile: null,
    retentionsFiles: [],
    uploadRetentionsFiles: [],
    currency: CurrencyType.ARS,
    status: SaleStatus.BILLED,
    anotherRetentions: 0,
    earningsRetention: 0,
    exchangeType: 0,
    grossAmount: 0,
    grossIvaAmount: 0,
    iibbBsAs: 0,
    iibbCaba: 0,
    iibbCordoba: 0,
    iibbMendoza: 0,
    iibbNeuquen: 0,
    iibbRioNegro: 0,
    iibbSalta: 0,
    iibbSantaCruz: 0,
    iibbSantaFe: 0,
    iva: 0,
    ivaRetention: 0,
    receivedAmount: 0,
    sussRetention: 0,
    totalAmount: 0,
    usdAmount: 0
  };

  const [sale, setSale] = useState(initialValues);

  const validationSchema = Yup.object({
    invoiceNumber: Yup.string().required('El Numero de Factura es requerido'),
    client: Yup.object().required('El Cliente es requerido'),
    saleType: Yup.object().required('El Tipo es requerido'),
    serviceOrder: Yup.object().required('La Orden de Servicio es requerida'),
    presentationDate: Yup.object().required('La Fecha de Presentacion es requerida'),
    estimatedCollectionDate: Yup.object().required('La Fecha Estimada Cobro es requerida'),
    currency: Yup.string().required('La Divisa es requerida'),
    effectiveCollectionDate: Yup.string().when('status', (status: any) => {
      if (status[0] === SaleStatus.CASHED) {
        return Yup.string().required('La Fecha de Cobro es requerida')
      }
      return Yup.string().notRequired()
    }),
    uploadInvoiceFile: Yup.string().when('invoiceFile', (invoiceFile: any) => {
      if (invoiceFile[0] === null) {
        return Yup.mixed().required('El Comprobante es requerido')
      }
      return Yup.mixed().notRequired()
    }),
    // uploadRetentionsFile: Yup.mixed().when(['retentionsFile', 'status'], ([retentionsFile, status], schema) => {
    //   if ((retentionsFile === null || retentionsFile === undefined) && status === SaleStatus.CASHED) {
    //     return schema.required('El Comprobante de Retenciones es requerido');
    //   }
    //   return schema.notRequired();
    // }),
    usdAmount: Yup.number().when(['saleType', 'currency'], ([saleType, currency], schema) => {
      if (currency === CurrencyType.USR && saleType?.id === 3) {
        return schema
          .required('El Monto Bruto en Dólares es requerido')
          .max(0, "El valor no puede ser mayor a 0");
      }

      return schema
        .required('El Monto Bruto en Dólares es requerido')
        .min(0, "El valor minimo es 0");
    }),
    grossAmount: Yup.number().when('saleType', (saleType: any, schema)=> {
      if (saleType[0]?.id === 3) {
        return schema.required('El Monto Bruto en Pesos es requerido').max(0, "El valor no puede ser mayor 0");
      } else {
        return schema.required('El Monto Bruto en Pesos es requerido').min(0, "El valor minimo es 0");
      }
    }),
    iva: Yup.number().when('saleType', (saleType: any, schema)=> {
      if (saleType[0]?.id === 3) {
        return schema.required('El IVA es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El IVA es requerido').min(0, "El valor minimo es 0");
      }
    }),
    grossIvaAmount: Yup.number().when('saleType', (saleType: any, schema)=> {
      if (saleType[0]?.id === 3) {
        return schema.required('El Monto con IVA es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El Monto con IVA es requerido').min(0, "El valor minimo es 0");
      }
    }),
    exchangeType: Yup.number().required('El Tipo de Cambio es requerido').min(0, "El valor minimo es 0"),
    receivedAmount: Yup.number().required('El Monto Percibido es requerido').min(0, "El valor minimo es 0"),
    earningsRetention: Yup.number().required('La Retencion de Ganancias es requerida').min(0, "El valor minimo es 0"),
    ivaRetention: Yup.number().required('La Retencion IVA es requerida').min(0, "El valor minimo es 0"),
    sussRetention: Yup.number().required('La Retencion SUSS es requerida').min(0, "El valor minimo es 0"),
    iibbBsAs: Yup.number().required('La Retencion II.BB Bs. As. es requerida').min(0, "El valor minimo es 0"),
    iibbCaba: Yup.number().required('La Retencion II.BB CABA es requerida').min(0, "El valor minimo es 0"),
    iibbCordoba: Yup.number().required('La Retencion II.BB Cordoba es requerida').min(0, "El valor minimo es 0"),
    iibbMendoza: Yup.number().required('La Retencion II.BB Mendoza es requerida').min(0, "El valor minimo es 0"),
    iibbNeuquen: Yup.number().required('La Retencion II.BB Neuquen es requerida').min(0, "El valor minimo es 0"),
    iibbRioNegro: Yup.number().required('La Retencion II.BB Rio Negro es requerida').min(0, "El valor minimo es 0"),
    iibbSalta: Yup.number().required('La Retencion II.BB Salta es requerida').min(0, "El valor minimo es 0"),
    iibbSantaCruz: Yup.number().required('La Retencion II.BB Santa Cruz es requerida').min(0, "El valor minimo es 0"),
    iibbSantaFe: Yup.number().required('La Retencion II.BB Santa Fe es requerida').min(0, "El valor minimo es 0"),
    anotherRetentions: Yup.number().required('Otras Retenciones es requerido').min(0, "El valor minimo es 0"),
    totalAmount: Yup.number().required('El Monto Total es requerido').min(0, "El valor minimo es 0"),
  });

  const onSubmit = (sale: ISale) => {
    if (id) {
      update(sale.id, sale)
        .then(() => {
          showNotification({type: 'success', message: 'Venta creada correctamente.'});
          // goBack();
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    } else {
      create(sale)
        .then((response) => {
          showNotification({type: 'success', message: 'Venta actualizada correctamente.'});
          goBack();
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit,
    validationSchema: validationSchema,
  });

  const handleChangePresentationDate = (value: Moment | null) => {
    const estimatedCollectionDate = moment(value).add(30, 'days');
    formik.setFieldValue('presentationDate', value ? moment(value) : null);
    formik.setFieldValue('estimatedCollectionDate', estimatedCollectionDate);
  };

  const handleChangeEstimatedCollectionDate = (value: Moment | null) => {
    formik.setFieldValue('estimatedCollectionDate', value ? moment(value) : null)
  };

  const handleChangeCurrency = (event: SelectChangeEvent) => {
    formik.setFieldValue('currency', event.target.value);
    formik.setFieldValue('usdAmount', 0);
    formik.setFieldValue('exchangeType', 0);
    formik.setFieldValue('grossAmount', 0);
  };

  const handleChangeEffectiveCollectionDate = (value: Moment | null) => {
    formik.setFieldValue('effectiveCollectionDate', value ? moment(value) : null)
  };

  const handleChangeSaleType = (event: SelectChangeEvent) => {
    const selectedSaleType = saleTypes.find(acc => acc.id === event.target.value);
    formik.setFieldValue('saleType', selectedSaleType)
  };

  const handleRemoveFile = (index: number) => {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
  };



  const goBack = () => {
    navigate(-1)
  };

  const fetchClients = async () => {
    getActiveClients().then( (response) => {
      setClients(response.data)
    })
  };

  const fetchSaleTypes = async () => {
    getActiveSaleTypes().then( (response) => {
      setSaleTypes(response.data)
      if (!id) {
        formik.setFieldValue('saleType', response.data[0])
      }
    })
  };

  const fetchSale = async () => {
    if (id) {
      getById(id).then( (response) => {
        let saleData = response.data;
        setSale(saleData);
        formik.setValues({
          ...saleData,
          presentationDate: moment(saleData.presentationDate),
          estimatedCollectionDate: moment(saleData.estimatedCollectionDate),
          effectiveCollectionDate: saleData.effectiveCollectionDate ? moment(saleData.effectiveCollectionDate) : null,
        });
      })
    }
  };

  const onInputChange = (event: React.SyntheticEvent, value: string, reason: AutocompleteInputChangeReason) => {
    if (value.length > 1) {
      findServiceOrders({keyword: value})
        .then( (response) => {
          setServiceOrders(response.data)
        })
    }
  };

  useEffect(() => {
    setFiles([])
    if (sale.serviceOrder?.id) {
      setSelectedServiceOrders(sale.serviceOrder);
      setServiceOrders([sale.serviceOrder as IServiceOrder]);
    }
  }, [sale.serviceOrder?.id]);

  const onConfirm = () => {
    if (selectedStatus === SaleStatus.PENDING_COLLECTION) {
      formik.setFieldValue('status', selectedStatus);
      formik.handleSubmit()
    } else if (selectedStatus === SaleStatus.CASHED_IN_PROGRESS) {
      formik.setFieldValue('status', selectedStatus);
    } else {
      formik.setFieldValue('status', selectedStatus);
    }

    setSelectedStatus(null);
    setConfirmationModalOpen(false);
  };

  const handleConfirmationModalClose = () => {
    setSelectedStatus(null);
    setConfirmationModalOpen(false);
  }

  const handleOpenChangeStatusModal = (status: SaleStatus) => {
    if (status === SaleStatus.PENDING_COLLECTION) {
      setModalTitle("Cambio de Estado a: Pendiente de Cobro");
      setModalMessage("Al confirmar se cambiara el estado de la venta a Pendiente de Cobro.")
    } else if (status === SaleStatus.CASHED_IN_PROGRESS) {
      setModalTitle("Cambio de Estado a: En Proceso de Cobro");
      setModalMessage("Al confirmar se cambiara el estado de la venta a En Proceso de Cobro.")
    } else {
      setModalTitle("Cambio de Estado a: Cobrado");
      setModalMessage("Al confirmar esta accion se habilitara la carga de las retenciones. ")
    }
    setSelectedStatus(status);
    setConfirmationModalOpen(true);
  };

  useEffect(() => {
    if (formik.values.currency === CurrencyType.USR) {
      const usdAmount = Number(formik.values.usdAmount) || 0;
      const exchangeType = Number(formik.values.exchangeType) || 0;
      const grossAmount = usdAmount * exchangeType;
      const iva = grossAmount * 0.21;
      const grossIvaAmount = grossAmount + iva;

      formik.setFieldValue('grossAmount', Number(grossAmount).toFixed(2));
      formik.setFieldValue('iva', Number(iva).toFixed(2));
      formik.setFieldValue('grossIvaAmount', Number(grossIvaAmount).toFixed(2));
    } else {
      const grossAmount = Number(formik.values.grossAmount) || 0;
      const iva = grossAmount * 0.21;
      const grossIvaAmount = grossAmount + iva;

      formik.setFieldValue('iva', Number(iva).toFixed(2));
      formik.setFieldValue('grossIvaAmount', Number(grossIvaAmount).toFixed(2));
    }
  }, [
    formik.values.grossAmount,
    formik.values.usdAmount,
    formik.values.exchangeType
  ]);

  useEffect(() => {
    const anotherRetentions = Number(formik.values.anotherRetentions) || 0;
    const earningsRetention = Number(formik.values.earningsRetention) || 0;
    const iibbBsAs = Number(formik.values.iibbBsAs) || 0;
    const iibbCaba = Number(formik.values.iibbCaba) || 0;
    const iibbCordoba = Number(formik.values.iibbCordoba) || 0;
    const iibbMendoza = Number(formik.values.iibbMendoza) || 0;
    const iibbNeuquen = Number(formik.values.iibbNeuquen) || 0;
    const iibbRioNegro = Number(formik.values.iibbRioNegro) || 0;
    const iibbSalta = Number(formik.values.iibbSalta) || 0;
    const iibbSantaCruz = Number(formik.values.iibbSantaCruz) || 0;
    const iibbSantaFe = Number(formik.values.iibbSantaFe) || 0;
    const ivaRetention = Number(formik.values.ivaRetention) || 0;
    const receivedAmount = Number(formik.values.receivedAmount) || 0;
    const sussRetention = Number(formik.values.sussRetention) || 0;

    const totalAmount = anotherRetentions + earningsRetention + iibbBsAs + iibbCaba + iibbCordoba +
      iibbMendoza + iibbNeuquen + iibbRioNegro + iibbSalta + iibbSantaCruz + iibbSantaFe + ivaRetention +
      receivedAmount + sussRetention;

    formik.setFieldValue('totalAmount', Number(totalAmount).toFixed(2));
  }, [
    formik.values.anotherRetentions,
    formik.values.earningsRetention,
    formik.values.iibbBsAs,
    formik.values.iibbCaba,
    formik.values.iibbCordoba,
    formik.values.iibbMendoza,
    formik.values.iibbNeuquen,
    formik.values.iibbRioNegro,
    formik.values.iibbSalta,
    formik.values.iibbSantaCruz,
    formik.values.iibbSantaFe,
    formik.values.ivaRetention,
    formik.values.receivedAmount,
    formik.values.sussRetention
  ]);

  useEffect(() => {
    fetchClients();
    fetchSale();
    fetchSaleTypes();
  }, []);

  return (
    <Box
      sx={{
        px: { xs: 2},
        pt: { xs: 'calc(12px + var(--Header-height))' },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100dvh',
        overflow: "auto"
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: { xs: 1 },
              width: '100%',
            }}
          >
            <Breadcrumbs
              size="sm"
              aria-label="breadcrumbs"
              separator={<ChevronRightRoundedIcon/>}
              sx={{ pl: 0 }}
            >
              <Typography level="h4" component="h1">
                <PointOfSaleIcon fontSize="small" sx={{ fontSize: 30, marginTop: -1}} />
              </Typography>
              <Typography level="h4" component="h1">
                Control Financiero
              </Typography>
              <Typography level="h4" component="h1">
                <Link
                  underline={"none"}
                  onClick={() => goBack()}
                  sx={{ cursor: 'pointer' }}
                >
                  Ventas
                </Link>
              </Typography>
              <Typography level="h4" component="h1">
                {id ? "Editar" : "Nuevo"}
              </Typography>
            </Breadcrumbs>
            <Box>
              <CssVarsProvider>
                <ChipMaterial color={SaleStatusColors[SaleStatus[formik.values.status as keyof typeof SaleStatus]]}
                              label={SaleStatusNames[SaleStatus[formik.values.status as keyof typeof SaleStatus]]}
                              sx={{width: 200, fontWeight: 'bold', fontSize: 18}}/>
              </CssVarsProvider>
            </Box>
          </Box>

          <ConfirmationModal
            open={confirmationModalOpen}
            onConfirm={onConfirm}
            onCancel={handleConfirmationModalClose}
            title={modalTitle}
            message={modalMessage}
            isDeleteAction={false}
          />

          <Box sx={{ width: '100%', typography: 'body1' }}>
            <form className="form" onSubmit={formik.handleSubmit}>
              <Grid
                container
                rowSpacing={2}
                columnSpacing={2}
                marginBlock={1}
                marginInline={0}
                sx={{ width: '100%' }}
              >

                {/*Row 1*/}
                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="invoiceNumber"
                      label="Factura Numero"
                      name="invoiceNumber"
                      variant="filled"
                      type={"text"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.invoiceNumber}
                      slotProps={{ inputLabel: {shrink: true}}}
                      error={!!(formik.touched.invoiceNumber && formik.errors.invoiceNumber)}
                    />
                    {formik.touched.invoiceNumber && formik.errors.invoiceNumber ? (
                      <span className="Error-alert">{formik.errors.invoiceNumber}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="invoiceType-label" shrink>Tipo</InputLabel>
                      <Select
                        labelId="invoiceType-label"
                        id="invoiceType"
                        name="invoiceType"
                        label="invoiceType"
                        value={formik.values.saleType ? formik.values.saleType.id : ""}
                        onBlur={formik.handleBlur}
                        onChange={handleChangeSaleType}
                      >
                        {saleTypes?.map((saleType) => (
                          <MenuItem key={saleType.id} value={saleType.id}>{saleType.name}</MenuItem>
                        ))}
                      </Select>
                      {formik.touched.saleType && formik.errors.saleType ? (
                        <span className="Error-alert">{String(formik.errors.saleType)}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="currency-label" shrink>Divisa</InputLabel>
                      <Select
                        labelId="currency-label"
                        id="currency"
                        name="currency"
                        label="Divisa"
                        value={formik.values.currency}
                        onBlur={formik.handleBlur}
                        onChange={handleChangeCurrency}
                      >
                        {Object
                          .keys(CurrencyType)
                          .filter((key) => isNaN(Number(key)))
                          .map((key) => (
                          <MenuItem key={key} value={CurrencyType[key as keyof typeof CurrencyType]}>
                            {CurrencyTypeNames[CurrencyType[key as keyof typeof CurrencyType]]}
                          </MenuItem>
                        ))}
                      </Select>
                      {formik.touched.currency && formik.errors.currency ? (
                        <span className="Error-alert">{String(formik.errors.currency)}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                {/*Row 2*/}
                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        name="start"
                        label="Fecha de Presentacion"
                        format="DD/MM/YYYY"
                        value={formik.values.presentationDate ? moment(formik.values.presentationDate) : null }
                        onChange={handleChangePresentationDate}
                        slotProps={{
                          textField: {
                            variant: 'filled',
                            fullWidth: true,
                            onChange: formik.handleChange,
                            onBlur: formik.handleBlur,
                            error: formik.touched.presentationDate && Boolean(formik.errors.presentationDate),
                            InputLabelProps: {
                              shrink:  true
                            }
                          }
                        }} />
                    </LocalizationProvider>
                    {formik.touched.presentationDate && formik.errors.presentationDate ? (
                      <span className="Error-alert">{formik.errors.presentationDate}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        name="start"
                        label="Fecha Estimada de Cobro"
                        format="DD/MM/YYYY"
                        value={formik.values.estimatedCollectionDate ? moment(formik.values.estimatedCollectionDate) : null }
                        onChange={handleChangeEstimatedCollectionDate}
                        slotProps={{
                          textField: {
                            variant: 'filled',
                            fullWidth: true,
                            onChange: formik.handleChange,
                            onBlur: formik.handleBlur,
                            error: formik.touched.estimatedCollectionDate && Boolean(formik.errors.estimatedCollectionDate),
                            InputLabelProps: {
                              shrink:  true
                            }
                          }
                        }} />
                    </LocalizationProvider>
                    {formik.touched.estimatedCollectionDate && formik.errors.estimatedCollectionDate ? (
                      <span className="Error-alert">{formik.errors.estimatedCollectionDate}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="usdAmount"
                      label="Monto Bruto en Dólares"
                      name="usdAmount"
                      variant="filled"
                      type={"number"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.usdAmount}
                      error={!!(formik.touched.usdAmount && formik.errors.usdAmount)}
                      slotProps={{ inputLabel: {shrink: true}}}
                      disabled={formik.values.currency !== CurrencyType.USR}
                    />
                    {formik.touched.usdAmount && formik.errors.usdAmount ? (
                      <span className="Error-alert">{String(formik.errors.usdAmount)}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="exchangeType"
                      label="Tipo de Cambio"
                      name="exchangeType"
                      variant="filled"
                      type={"number"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.exchangeType}
                      error={!!(formik.touched.exchangeType && formik.errors.exchangeType)}
                      slotProps={{ inputLabel: {shrink: true}}}
                      disabled={formik.values.currency !== CurrencyType.USR}
                    />
                    {formik.touched.exchangeType && formik.errors.exchangeType ? (
                      <span className="Error-alert">{formik.errors.exchangeType}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                {/*Row 3*/}
                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="role-label" shrink>Orden de Servicio</InputLabel>
                      <Autocomplete
                        id="serviceOrder-autocomplete"
                        value={selectedServiceOrders}
                        getOptionLabel={(serviceOrder) =>
                          `${serviceOrder.number}`
                        }
                        onInputChange={onInputChange}
                        options={serviceOrders}
                        disableClearable
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onChange={(e, value) => {
                          setSelectedServiceOrders(value);
                          formik.setFieldValue('serviceOrder', value);
                        }}
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant={"filled"}
                            slotProps={{ inputLabel: {shrink: true, type: 'search'}}}
                            onBlur={formik.handleBlur}
                          />
                        )}
                      />
                      {formik.touched.serviceOrder && formik.errors.serviceOrder ? (
                        <span className="Error-alert">{String(formik.errors.serviceOrder)}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="grossAmount"
                      label="Monto Bruto en Pesos"
                      name="grossAmount"
                      variant="filled"
                      type={"number"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.grossAmount}
                      error={!!(formik.touched.grossAmount && formik.errors.grossAmount)}
                      slotProps={{inputLabel: {shrink: true}, input: {readOnly: formik.values.currency !== CurrencyType.ARS}}}
                    />
                    {formik.touched.grossAmount && formik.errors.grossAmount ? (
                      <span className="Error-alert">{String(formik.errors.grossAmount)}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="iva"
                      label="IVA"
                      name="iva"
                      variant="filled"
                      type={"number"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.iva}
                      error={!!(formik.touched.iva && formik.errors.iva)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true} }}
                    />
                  </CssVarsProvider>
                </Grid>

                {/*Row 4*/}
                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <Autocomplete
                      id="provider"
                      value={formik.values.client}
                      getOptionLabel={(client) =>
                        `${client?.name || ''} - CUIT: ${client?.cuit || '...'}`
                      }
                      options={clients}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      onChange={(e, value) => {
                        formik.setFieldValue('client', value);
                      }}
                      fullWidth
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="filled"
                          name="client"
                          label="Cliente"
                          slotProps={{ inputLabel: { shrink: true } }}
                          onBlur={formik.handleBlur}
                          error={!!(formik.touched.client && formik.errors.client)}
                        />
                      )}
                    />
                    {formik.touched.client && formik.errors.client ? (
                      <span className="Error-alert">{String(formik.errors.client)}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="grossIvaAmount"
                      label="Monto con IVA"
                      name="grossIvaAmount"
                      variant="filled"
                      type={"number"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.grossIvaAmount}
                      error={!!(formik.touched.grossIvaAmount && formik.errors.grossIvaAmount)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true} }}
                    />
                  </CssVarsProvider>
                </Grid>

                {/*Row 5*/}
                <Grid xl={12} md={12} sm={12} xs={12}>
                  <Card sx={{height: 57, padding: 1, margin:0}}>
                    <Stack direction={"row"} justifyContent={"space-between"}>
                      <Stack direction={"row"} justifyContent={"center"}>
                        <Typography sx={{fontWeight: "bold"}} pt={1} pr={1}>
                          Comprobante:
                        </Typography>
                        {formik.values.uploadInvoiceFile ?
                          <Chip
                            variant="outlined"
                            color="neutral"
                            size="lg"
                          >
                            {formik.values.uploadInvoiceFile.name}
                          </Chip>
                          :
                          sale?.invoiceFile ?
                            <Chip
                              variant="outlined"
                              color="neutral"
                              size="lg"
                              onClick={() => downloadFile(sale?.invoiceFile)}
                              endDecorator={<DownloadForOfflineIcon sx={{ fontSize: 30}}/>}
                            >
                              {sale.invoiceFile.fileName}
                            </Chip>
                            :
                            <Typography pt={1} pr={1}>
                              No hay archivo adjunto
                            </Typography>
                        }
                      </Stack>
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <input
                          id="uploadInvoiceFile"
                          name="uploadInvoiceFile"
                          type="file"
                          accept=".pdf,application/pdf"
                          style={{display: 'none'}}
                          onChange={(event) => {
                            if (event.currentTarget.files && event.currentTarget.files.length > 0) {
                              const newFile = event.currentTarget.files[0];
                              formik.setFieldValue("uploadInvoiceFile", newFile);
                            }
                          }}
                        />
                        <IconButton onClick={() => document.getElementById('uploadInvoiceFile')?.click()}>
                          <CloudUploadIcon sx={{ fontSize: 40}} />
                        </IconButton>
                      </Stack>
                    </Stack>
                  </Card>
                  {formik.touched.uploadInvoiceFile && formik.errors.uploadInvoiceFile ? (
                    <span className="Error-alert">{formik.errors.uploadInvoiceFile}</span>
                  ) : null}
                </Grid>

                {/*Retention data*/}
                {[SaleStatus.CASHED, SaleStatus.CASHED_IN_PROGRESS].includes(formik.values.status) &&
                  <Grid
                    container
                    rowSpacing={2}
                    columnSpacing={2}
                    marginBlock={0}
                    marginInline={0}
                    padding={0}
                    sx={{ width: '100%' }}
                  >
                    <Grid xl={12} md={12} sm={12} xs={12}>
                      <Divider >
                        <Chip variant="soft" color="neutral" size="sm">
                          Retenciones
                        </Chip>
                      </Divider>
                    </Grid>

                    {/*Row 1*/}
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            name="start"
                            label="Fecha Efectiva de Cobro"
                            format="DD/MM/YYYY"
                            value={formik.values.effectiveCollectionDate ? moment(formik.values.effectiveCollectionDate) : null }
                            onChange={handleChangeEffectiveCollectionDate}
                            slotProps={{
                              textField: {
                                variant: 'filled',
                                fullWidth: true,
                                onChange: formik.handleChange,
                                onBlur: formik.handleBlur,
                                error: formik.touched.effectiveCollectionDate && Boolean(formik.errors.effectiveCollectionDate),
                                InputLabelProps: {
                                  shrink:  true
                                }
                              }
                            }} />
                        </LocalizationProvider>
                        {formik.touched.effectiveCollectionDate && formik.errors.effectiveCollectionDate ? (
                          <span className="Error-alert">{formik.errors.effectiveCollectionDate}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="receivedAmount"
                          label="Monto Percibido"
                          name="receivedAmount"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.receivedAmount}
                          error={!!(formik.touched.receivedAmount && formik.errors.receivedAmount)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.receivedAmount && formik.errors.receivedAmount ? (
                          <span className="Error-alert">{formik.errors.receivedAmount}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    {/*Row 2*/}
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="earningsRetention"
                          label="Retención Ganancias"
                          name="earningsRetention"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.earningsRetention}
                          error={!!(formik.touched.earningsRetention && formik.errors.earningsRetention)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.earningsRetention && formik.errors.earningsRetention ? (
                          <span className="Error-alert">{formik.errors.earningsRetention}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="ivaRetention"
                          label="Retención IVA"
                          name="ivaRetention"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.ivaRetention}
                          error={!!(formik.touched.ivaRetention && formik.errors.ivaRetention)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.ivaRetention && formik.errors.ivaRetention ? (
                          <span className="Error-alert">{formik.errors.ivaRetention}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    {/*Row 3*/}
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="sussRetention"
                          label="Retención SUSS"
                          name="sussRetention"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.sussRetention}
                          error={!!(formik.touched.sussRetention && formik.errors.sussRetention)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.sussRetention && formik.errors.sussRetention ? (
                          <span className="Error-alert">{formik.errors.sussRetention}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbBsAs"
                          label="Retención II.BB Bs. As."
                          name="iibbBsAs"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbBsAs}
                          error={!!(formik.touched.iibbBsAs && formik.errors.iibbBsAs)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbBsAs && formik.errors.iibbBsAs ? (
                          <span className="Error-alert">{formik.errors.iibbBsAs}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    {/*Row 4*/}
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbCaba"
                          label="Retención II.BB CABA"
                          name="iibbCaba"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbCaba}
                          error={!!(formik.touched.iibbCaba && formik.errors.iibbCaba)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbCaba && formik.errors.iibbCaba ? (
                          <span className="Error-alert">{formik.errors.iibbCaba}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbNeuquen"
                          label="Retención II.BB Neuquen"
                          name="iibbNeuquen"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbNeuquen}
                          error={!!(formik.touched.iibbNeuquen && formik.errors.iibbNeuquen)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbNeuquen && formik.errors.iibbNeuquen ? (
                          <span className="Error-alert">{formik.errors.iibbNeuquen}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    {/*Row 5*/}
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbSantaFe"
                          label="Retención II.BB Santa Fe"
                          name="iibbSantaFe"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbSantaFe}
                          error={!!(formik.touched.iibbSantaFe && formik.errors.iibbSantaFe)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbSantaFe && formik.errors.iibbSantaFe ? (
                          <span className="Error-alert">{formik.errors.iibbSantaFe}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbSantaCruz"
                          label="Retención II.BB Santa Cruz"
                          name="iibbSantaCruz"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbSantaCruz}
                          error={!!(formik.touched.iibbSantaCruz && formik.errors.iibbSantaCruz)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbSantaCruz && formik.errors.iibbSantaCruz ? (
                          <span className="Error-alert">{formik.errors.iibbSantaCruz}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    {/*Row 6*/}
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbRioNegro"
                          label="Retención II.BB Rio Negro"
                          name="iibbRioNegro"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbRioNegro}
                          error={!!(formik.touched.iibbRioNegro && formik.errors.iibbRioNegro)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbRioNegro && formik.errors.iibbRioNegro ? (
                          <span className="Error-alert">{formik.errors.iibbRioNegro}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbCordoba"
                          label="Retención II.BB Cordoba"
                          name="iibbCordoba"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbCordoba}
                          error={!!(formik.touched.iibbCordoba && formik.errors.iibbCordoba)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbCordoba && formik.errors.iibbCordoba ? (
                          <span className="Error-alert">{formik.errors.iibbCordoba}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    {/*Row 7*/}
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbMendoza"
                          label="Retención II.BB Mendoza"
                          name="iibbMendoza"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbMendoza}
                          error={!!(formik.touched.iibbMendoza && formik.errors.iibbMendoza)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbMendoza && formik.errors.iibbMendoza ? (
                          <span className="Error-alert">{formik.errors.iibbMendoza}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="iibbSalta"
                          label="Retención II.BB Salta"
                          name="iibbSalta"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.iibbSalta}
                          error={!!(formik.touched.iibbSalta && formik.errors.iibbSalta)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.iibbSalta && formik.errors.iibbSalta ? (
                          <span className="Error-alert">{formik.errors.iibbSalta}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    {/*Row 8*/}
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="anotherRetentions"
                          label="Retención Otros Conceptos"
                          name="anotherRetentions"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.anotherRetentions}
                          error={!!(formik.touched.anotherRetentions && formik.errors.anotherRetentions)}
                          slotProps={{ inputLabel: {shrink: true}}}
                        />
                        {formik.touched.anotherRetentions && formik.errors.anotherRetentions ? (
                          <span className="Error-alert">{formik.errors.anotherRetentions}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="totalAmount"
                          label="Total"
                          name="totalAmount"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.totalAmount}
                          error={!!(formik.touched.totalAmount && formik.errors.totalAmount)}
                          slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true}}}
                        />
                      </CssVarsProvider>
                    </Grid>

                    {/*Row 9*/}
                    <Grid xl={12} md={12} sm={12} xs={12}>
                      <Card sx={{height: 57, padding: 1, margin:0}}>
                        <Stack direction={"row"} justifyContent={"space-between"}>
                          <Stack direction={"row"} justifyContent={"center"}>
                            <Typography sx={{fontWeight: "bold"}} pt={1} pr={1}>
                              Comprobante de Retenciones:
                            </Typography>
                            {formik.values.uploadRetentionsFile ?
                              <Chip
                                variant="outlined"
                                color="neutral"
                                size="lg"
                              >
                                {formik.values.uploadRetentionsFile.name}
                              </Chip>
                              :
                              sale?.retentionsFile ?
                                <Chip
                                  variant="outlined"
                                  color="neutral"
                                  size="lg"
                                  onClick={() => downloadFile(sale?.retentionsFile)}
                                  endDecorator={<DownloadForOfflineIcon sx={{ fontSize: 30}}/>}
                                >
                                  {sale.retentionsFile.fileName}
                                </Chip>
                                :
                                <Typography pt={1} pr={1}>
                                  No hay archivo adjunto
                                </Typography>
                            }
                          </Stack>
                          <Stack direction={"row"} justifyContent={"space-between"}>
                            <input
                              id="uploadRetentionsFile"
                              name="uploadRetentionsFile"
                              type="file"
                              accept=".pdf,application/pdf"
                              style={{display: 'none'}}
                              onChange={(event) => {
                                if (event.currentTarget.files && event.currentTarget.files.length > 0) {
                                  const newFile = event.currentTarget.files[0];
                                  formik.setFieldValue("uploadRetentionsFile", newFile);
                                }
                              }}
                            />
                            <IconButton
                              onClick={() => document.getElementById('uploadRetentionsFile')?.click()}
                              disabled={true}
                            >
                              <CloudUploadIcon sx={{ fontSize: 40}} />
                            </IconButton>
                          </Stack>
                        </Stack>
                      </Card>
                      {formik.touched.uploadRetentionsFile && formik.errors.uploadRetentionsFile ? (
                        <span className="Error-alert">{formik.errors.uploadRetentionsFile}</span>
                      ) : null}
                    </Grid>





                    {sale && sale.retentionsFiles?.length > 0 && (
                      <Grid xl={12} md={12} sm={12} xs={12}>
                        <CssVarsProvider>
                          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                            {sale.retentionsFiles.map((file, index) => (
                              <ListItem
                                secondaryAction={
                                  <IconButtonMaterial
                                    edge="end"
                                    aria-label="download"
                                    onClick={() => downloadFile(file)}
                                  >
                                    <DownloadForOfflineIcon />
                                  </IconButtonMaterial>
                                }
                              >
                                <ListItemAvatar>
                                  <Avatar>
                                    <FilePresentIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={file.fileName} secondary={moment(file.uploaded).format('DD-MM-YYYY hh:mm:ss')} />
                              </ListItem>
                            ))}
                          </List>
                        </CssVarsProvider>
                      </Grid>
                    )}

                    {files.length > 0 && (
                      <Grid xl={12} md={12} sm={12} xs={12}>
                        <Divider />
                        <CssVarsProvider>
                          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                            {files.map((file, index) => (
                              <ListItem
                                secondaryAction={
                                  <IconButtonMaterial
                                    onClick={() => handleRemoveFile(index)}
                                    edge="end"
                                    aria-label="delete">
                                    <DeleteIcon />
                                  </IconButtonMaterial>
                                }
                              >
                                <ListItemAvatar>
                                  <Avatar >
                                    <FilePresentIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={file.name} />
                              </ListItem>
                            ))}
                          </List>
                        </CssVarsProvider>
                      </Grid>
                    )}

                    <Grid xl={12} md={12} sm={12} xs={12}>
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <input
                          id="files"
                          name="files"
                          type="file"
                          multiple
                          style={{display: 'none'}}
                          onChange={(event) => {
                            if (event.currentTarget.files) {
                              const newFiles = Array.from(event.currentTarget.files);
                              setFiles( [...files, ...newFiles]);
                              formik.setFieldValue('uploadRetentionsFiles', [...files, ...newFiles]);
                            }
                          }}
                        />
                        <Button
                          fullWidth
                          variant="solid"
                          color="primary"
                          onClick={() => document.getElementById('files')?.click()}
                        >
                          Adjuntar nuevo Archivo
                        </Button>
                      </Stack>
                    </Grid>

                  </Grid>
                }
              </Grid>

              <Stack direction="row" justifyContent="space-between" spacing={2} pr={1} pl={1} mb={2}>

                <Stack direction="row" justifyContent="flex-start" spacing={2}>
                  {id && formik.values.status === SaleStatus.BILLED &&
                      <Button
                        onClick={() => handleOpenChangeStatusModal(SaleStatus.PENDING_COLLECTION)}
                        variant="solid" color="warning" endDecorator={<AccessAlarmsIcon />}>Pendiente de Cobro</Button>
                  }
                  {id && formik.values.status === SaleStatus.PENDING_COLLECTION &&
                      <Button
                        onClick={() => handleOpenChangeStatusModal(SaleStatus.CASHED_IN_PROGRESS)}
                        variant="solid" color="primary" endDecorator={<AttachMoneyIcon />}>En Proceso de Cobro</Button>
                  }
                  {id && formik.values.status === SaleStatus.CASHED_IN_PROGRESS &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(SaleStatus.CASHED)}
                          variant="solid" color="success" endDecorator={<AttachMoneyIcon />}>Cobrada</Button>
                  }
                </Stack>

                <Stack direction="row" justifyContent="flex-end" spacing={2}>
                  <Button onClick={() => goBack()} variant="outlined" endDecorator={<ArrowBackIosNew />}>Volver</Button>
                  <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />} disabled={!editable}>Guardar</Button>
                </Stack>
              </Stack>
            </form>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SaleForm;
